class AgeConsentElement extends HTMLElement {
  static SESSION_KEY = "rememberageconsent";
  static VALIDATE_KEY = "customer_validate";
  static AGE_GATE_PATH = "/pages/age-gate";

  connectedCallback() {
    if (this.__inited) return;
    this.__inited = true;

    this.ensureCloseButton();
    this.bindClose();
    this.bindReverify();

    this.updateVisibility();
  }

  safeParse(json) {
    try {
      return JSON.parse(json);
    } catch {
      return null;
    }
  }

  hasSessionConsent() {
    const raw = sessionStorage.getItem(AgeConsentElement.SESSION_KEY);
    if (!raw) return false;

    if (raw === "true") return true;

    const parsed = this.safeParse(raw);
    return parsed !== null;
  }

  shouldShow() {
    const flagMissing = window.__REMEMBER_AGE_CONSENT_MISSING__ === true;
    const sessionOk = this.hasSessionConsent();
    return flagMissing && !sessionOk;
  }

  ensureCloseButton() {
    // Button already exists in your Liquid template:
    // <div class="age-consent-close" data-age-consent-close>...</div>
    if (this.querySelector("[data-age-consent-close]")) return;
  }

  bindClose() {
    const btn = this.querySelector("[data-age-consent-close]");
    if (!btn) return;

    btn.addEventListener("click", () => {
      // Set session consent so it won't show again in this session
      sessionStorage.setItem(
        AgeConsentElement.SESSION_KEY,
        JSON.stringify({ value: true, ts: Date.now() })
      );

      // Clear the in-memory flag for this page view
      window.__REMEMBER_AGE_CONSENT_MISSING__ = false;

      this.hide();
    });
  }

  bindReverify() {
    const link = this.querySelector("[data-age-consent-reverify]");
    if (!link || link.__ageConsentBound) return;
    link.__ageConsentBound = true;

    link.addEventListener("click", (e) => {
      e.preventDefault();

      // Clear stored validation so age-gate logic runs again
      try {
        localStorage.removeItem(AgeConsentElement.VALIDATE_KEY);
        sessionStorage.removeItem(AgeConsentElement.SESSION_KEY);
      } catch (_) {
        // No-op if storage is blocked
      }

      // Clear any in-memory flag
      window.__REMEMBER_AGE_CONSENT_MISSING__ = false;

      // Redirect to age-gate page
      window.location.href = AgeConsentElement.AGE_GATE_PATH;
    });
  }

  show() {
    this.classList.remove("hidden");
    this.removeAttribute("hidden");
    this.setAttribute("aria-hidden", "false");
  }

  hide() {
    this.classList.add("hidden");
    this.setAttribute("hidden", "");
    this.setAttribute("aria-hidden", "true");
  }

  updateVisibility() {
    if (this.shouldShow()) {
      this.show();
    } else {
      this.hide();
    }
  }
}

if (!customElements.get("age-consent")) {
  customElements.define("age-consent", AgeConsentElement);
}
